// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RW0jG","title":"Header_title__3M_0H","side":"Header_side__3OY8j"};